import { ConsentFormRenderer } from 'components/Teleconsent/renderer/ConsentFormRenderer';
import { getFormDefinition } from 'components/Teleconsent/forms/dynamicRegistry';
import { useTeleconsent } from 'hooks';

export function TeleconsentContainerFullScreen() {
  const {
    isOpen,
    formKey,
    isHost,
    mode,
    fields,
    signature,
    receipt,
    clientDownloaded,
    hostScrollTarget,
    clientViewport,
    highlightedBlockId,
    participantName,
    providerName,
    clientLabel,
    goBackSignal,
    clientEndedSession,
    submitForm,
    endSession,
    updateField,
    setMode,
    scrollPosition,
    highlightBlock,
    notifyDownloaded,
    applySignature,
    notifyGoBack,
    notifyClientClosed,
    dismissClientEndedSession,
  } = useTeleconsent();

  if (!isOpen || !formKey) return null;

  const definition = getFormDefinition(formKey);
  if (!definition) return null;

  return (
    <ConsentFormRenderer
      definition={definition}
      isHost={isHost}
      mode={mode}
      onModeChange={isHost ? setMode : undefined}
      onScroll={scrollPosition}
      hostScrollTarget={hostScrollTarget}
      clientViewport={isHost ? clientViewport : undefined}
      highlightedBlockId={highlightedBlockId}
      onHighlightBlock={isHost ? highlightBlock : undefined}
      participantName={!isHost ? providerName ?? participantName : participantName}
      providerName={providerName ?? undefined}
      clientLabel={clientLabel}
      externalFieldState={fields}
      externalSignature={signature}
      receipt={receipt}
      clientDownloaded={clientDownloaded}
      onSubmit={submitForm}
      onClose={
        isHost
          ? endSession
          : () => {
              notifyClientClosed();
              endSession();
            }
      }
      clientEndedSession={isHost ? clientEndedSession : undefined}
      onDismissClientEnded={isHost ? dismissClientEndedSession : undefined}
      onDownload={!isHost ? notifyDownloaded : undefined}
      onFieldChange={(fieldId, value) => updateField(fieldId, value)}
      onApplySignature={!isHost ? applySignature : undefined}
      onGoBack={isHost ? notifyGoBack : undefined}
      goBackSignal={!isHost ? goBackSignal : undefined}
    />
  );
}
